import { AlpsAcatDetailV2WebDto } from '../api/types'
import {
  CLEAR_TRANSFER_DETAILS,
  GET_TRANSFER_DETAILS,
  GET_TRANSFER_DETAILS_FAILURE,
  GET_TRANSFER_DETAILS_SUCCESS,
} from '../actions'
import { TransferDetailsState } from '../types'

const INITIAL_STATE: TransferDetailsState = {
  transferDetails: undefined,
  loadingTransferDetails: true,
}

export const transferDetailsReducer = (
  state: TransferDetailsState = INITIAL_STATE,
  action: {
    type: string
    transferDetails?: AlpsAcatDetailV2WebDto
  }
): TransferDetailsState => {
  const { type, transferDetails } = action
  switch (type) {
    case GET_TRANSFER_DETAILS:
      return { ...INITIAL_STATE, loadingTransferDetails: true }
    case GET_TRANSFER_DETAILS_SUCCESS:
      return { ...state, loadingTransferDetails: false, transferDetails }
    case GET_TRANSFER_DETAILS_FAILURE:
      return { ...state, loadingTransferDetails: false }
    case CLEAR_TRANSFER_DETAILS:
      return { ...INITIAL_STATE, loadingTransferDetails: false }
    default:
      return state
  }
}
